export class AutoLoader {
    elemnent = null;
    callback = null;
    observer = null;

    constructor(id, callback) {
        if (id === null || id === undefined) {
            console.error('No id provided.');
            return;
        }

        if (Array.isArray(id)) {
            this.element = [];
            id.forEach((element) => {
                this.element.push(this.init(element, callback));
            });
        } else {
            this.element = this.init(id, callback);
        }
        
        this.callback = callback;

        if (!this.element) {
            console.error(`Element with id ${id} not found.`);
            return;
        }
    }

    init(elementId, callback) {
        const element = document.getElementById(elementId);
        this.callback = callback;

        if (!element) {
            console.error(`Element with id ${elementId} not found.`);
            return;
        }

        if (!this.observer) {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback();
                    }
                });
            });
        }

        this.observer.observe(element);
        return element;
    }

    addElement(elementId) {
        if (Array.isArray(this.element)) {
            this.element.push(this.init(elementId, this.callback));
        } else {
            this.element = [this.element, this.init(elementId, this.callback)];
        }
    }

    destroy() {
        if (Array.isArray(this.element)) {
            this.element.forEach((element) => {
                this.observer.unobserve(element);
            });
        } else {
            this.observer.unobserve(this.element);
        }
    }
}